import { Button } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { StateMessage } from "./StateMessage";

interface ErrorStateProps {
	/** What could not be loaded: "Couldn't load job errors". */
	title: string;
	/** The reason, when one is available. */
	detail?: string | null;
	onRetry?: () => void;
}

/** A load that failed with nothing to show in its place. */
export function ErrorState({ title, detail, onRetry }: ErrorStateProps) {
	return (
		<StateMessage
			role="alert"
			glyph={<ErrorOutline color="error" fontSize="large" />}
			title={title}
			detail={detail}
			action={
				onRetry && (
					<Button variant="outlined" size="small" onClick={onRetry}>
						Retry
					</Button>
				)
			}
		/>
	);
}
